<template lang="html">
<div class="sl-sp-page" :style="{'top': top}">
  <div class="sl-bg">{{data.title}}</div>
  <div class="sl-cnt">
    <p>{{data.cnt1}}</p>
    <p>{{data.cnt2}}</p>
  </div>
  <div class="sl-btn">
    <a @click="$router.go(-1)" v-if="data.showBtn1">{{data.btn1}}</a>
    <router-link :to="{ name: 'Dashboard'}" tag="a">{{data.btn2}}</router-link>
  </div>
</div>
</template>
<script>
export default {
  computed: {
    top() {
      return (document.documentElement.clientHeight - 300) / 2 + 'px'
    }
  },
  props: {
    data: {
      title: '',
      cnt1: '',
      cnt2: '',
      btn1: '',
      btn2: '',
      showBtn1: true
    }
  }
}
</script>
<style scoped>
.sl-sp-page {
  width: 700px;
  height: 300px;
  text-align: center;
  background: #F1F1F1;
  border-radius: 2px;
  margin: 0 auto;
  position: relative;
  top: 150px;
}

.sl-bg {
  font-family: AvenirNext-Heavy;
  font-size: 140px;
  color: #E2E2E2;
  letter-spacing: 0;
  line-height: 110px;
  padding-top: 65px;
}

.sl-cnt {
  font-family: Avenir-Medium;
  font-size: 24px;
  color: #4A4A4A;
  letter-spacing: 0;
  position: relative;
  top: -90px;
}

.sl-btn a {
  display: block;
  text-decoration: underline;
  font-size: 14px;
  color: #20a0ff;
  letter-spacing: 0;
  line-height: 14px;
  cursor: pointer;
}

.sl-btn a:first-child {
  margin-bottom: 14px;
}

.sl-btn {
  position: relative;
  bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// sl-sp-page.vue?cb8ac9e2